/**
 * 4WS Carpet Calculator + Adhesive Upsell
 * _ prefix on properties hides them from Shopify checkout
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-4ws-block]').forEach(function (block) {
    const inst = new FWSBlock(block);
    block._4wsInstance = inst;
  });
});

class FWSBlock {
  constructor(block) {
    this.block = block;
    this.sid = block.dataset['4wsBlock'];
    this.FIXED_WIDTH = 2;
    this.ADHESIVE_ID = 47753977790658;
    this.ADHESIVE_PRICE = 2.99;
    this.syncTimer = null;

    this.qtyInput     = document.getElementById('Quantity-' + this.sid);
    this.sizeEl       = document.getElementById('4ws-carpet-size-' + this.sid);
    this.areaEl       = document.getElementById('4ws-total-area-' + this.sid);
    this.totalPriceEl = document.getElementById('4ws-total-price-' + this.sid);
    this.enabledEl    = document.getElementById('4ws-adhesive-enabled-' + this.sid);
    this.priceEl      = document.getElementById('4ws-price-per-m2-' + this.sid);
    this.detailEl     = document.getElementById('4ws-adhesive-detail-' + this.sid);
    this.trackEl      = document.getElementById('4ws-sw-track-' + this.sid);
    this.thumbEl      = document.getElementById('4ws-sw-thumb-' + this.sid);
    this.noEl         = document.getElementById('4ws-label-no-' + this.sid);
    this.yesEl        = document.getElementById('4ws-label-yes-' + this.sid);
    this.indicatorEl  = document.getElementById('4ws-sync-indicator-' + this.sid);
    this.cansEl       = document.getElementById('4ws-cans-' + this.sid);
    this.carpetCostEl = document.getElementById('4ws-carpet-cost-' + this.sid);
    this.adhesCostEl  = document.getElementById('4ws-cost-' + this.sid);
    this.grandTotalEl = document.getElementById('4ws-grand-total-' + this.sid);

    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', () => { this.update(); this.scheduleSync(); });
      this.qtyInput.addEventListener('input',  () => { this.update(); this.scheduleSync(); });
    }

    this._injectFormProperties();
    this.update();
  }

  get qty()  { return Math.max(1, parseInt(this.qtyInput?.value) || 1); }
  get on()   { return this.enabledEl?.value === '1'; }
  get ppm2() { return parseInt(this.priceEl?.value) || 0; }
  get cans() { return this.qty; }

  fmt(cents) { return '\u00a3' + (cents / 100).toFixed(2); }
  sizeLabel() { return this.qty + 'm x ' + this.FIXED_WIDTH + 'm'; }
  areaLabel() { return (this.qty * this.FIXED_WIDTH).toFixed(2) + ' m\u00b2'; }

  _injectFormProperties() {
    const form = document.getElementById('product-form-' + this.sid);
    if (!form) return;
    const setHidden = (name, value) => {
      let el = form.querySelector(`input[name="${name}"]`);
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      el.value = value;
    };
    const refresh = () => {
      setHidden('properties[_Size]', this.sizeLabel());
      setHidden('properties[_Area]', this.areaLabel());
    };
    refresh();
    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', refresh);
      this.qtyInput.addEventListener('input',  refresh);
    }
  }

  update() {
    const qty    = this.qty;
    const area   = qty * this.FIXED_WIDTH;
    const carpet = qty * this.ppm2;
    const adh    = this.on ? this.cans * Math.round(this.ADHESIVE_PRICE * 100) : 0;
    const total  = carpet + adh;

    if (this.sizeEl)       this.sizeEl.innerHTML         = qty + 'm &times; ' + this.FIXED_WIDTH + 'm';
    if (this.areaEl)       this.areaEl.innerHTML         = area.toFixed(2) + ' m&sup2;';
    if (this.totalPriceEl) this.totalPriceEl.textContent = this.fmt(total);

    if (this.on) {
      if (this.cansEl)       this.cansEl.textContent       = this.cans + (this.cans === 1 ? ' can' : ' cans');
      if (this.carpetCostEl) this.carpetCostEl.textContent = this.fmt(carpet);
      if (this.adhesCostEl)  this.adhesCostEl.textContent  = '+' + this.fmt(adh);
      if (this.grandTotalEl) this.grandTotalEl.textContent = this.fmt(total);
    }

    this._updateToggleUI();
  }

  toggle() {
    if (!this.enabledEl) return;
    const on = !this.on;
    this.enabledEl.value = on ? '1' : '0';
    if (this.detailEl) this.detailEl.style.display = on ? 'block' : 'none';
    this.update();
    this.scheduleSync();
  }

  _updateToggleUI() {
    const on = this.on;
    if (this.trackEl) this.trackEl.style.background = on ? 'rgba(var(--color-button), 1)' : 'rgba(var(--color-foreground), 0.15)';
    if (this.thumbEl) this.thumbEl.style.transform = on ? 'translateX(22px)' : 'translateX(0)';
    if (this.noEl)  { this.noEl.style.fontWeight  = on ? '400' : '600'; this.noEl.style.opacity  = on ? '0.45' : '1'; }
    if (this.yesEl) { this.yesEl.style.fontWeight = on ? '600' : '400'; this.yesEl.style.opacity = on ? '1'    : '0.45'; }
  }

  scheduleSync() {
    clearTimeout(this.syncTimer);
    this.syncTimer = setTimeout(() => this.syncCart(), 400);
  }

  syncCart() {
    const target = this.on ? this.cans : 0;
    if (this.indicatorEl) this.indicatorEl.style.display = 'inline';
    const updates = {};
    updates[this.ADHESIVE_ID] = target;
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const sections = cart?.getSectionsToRender?.()?.map(s => s.id) ?? ['cart-icon-bubble'];
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
    })
    .then(r => r.json())
    .then(data => {
      if (this.indicatorEl) this.indicatorEl.style.display = 'none';
      if (data.sections && cart?.getSectionsToRender) {
        cart.getSectionsToRender().forEach(section => {
          const html = data.sections[section.id];
          if (!html) return;
          const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (!el) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const src = section.selector ? parsed.querySelector(section.selector) : parsed.querySelector('.shopify-section');
          if (src) el.innerHTML = src.innerHTML;
        });
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: '4ws-adhesive', cartData: data });
      }
    })
    .catch(() => { if (this.indicatorEl) this.indicatorEl.style.display = 'none'; });
  }
}
